import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import AddWorkflowModal from "../ModalImpl/AddWorkflowModal";

const Workflow = () => {
    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const selectedBranch = JSON.parse(localStorage.getItem('selected_branch'));

    const [showWorkflowModal, setShowWorkflowModal] = useState(false);
    const [modalType, setModalType] = useState(0); // 0-add, 1-edit, 2-view
    const [selectedRow, setSelectedRow] = useState({});
    const [allWorkflowList, setAllWorkflowList] = useState([]);
    const [workflowTableBody, setWorkflowTableBody] = useState([]);
    const [workflowForRender, setWorkflowForRender] = useState([]);
    const [searchText, setSearchText] = useState('');

    const body = {
        columns: [
            {
                label: '#',
                field: 'index',
                sort: 'asc',
                width: 10
            },
            {
                label: 'Workflow Name',
                field: 'workflowNameDisplay',
                width: 150,
                sort: 'asc',
            },
            {
                label: 'Base Catgory',
                field: 'basedCategory',
                width: 150,
                sort: 'asc',
            },
            {
                label: 'Categories',
                field: 'categoriesDisplay',
                sort: 'asc',
                width: 400,
            },
            {
                label: 'Action',
                field: 'action',
                sort: 'disabled',
                width: 100,
            }
        ],
        rows: workflowTableBody
    };

    useEffect(() => {
        if (token !== null && baseUrl !== null && selectedBranch !== null) {
            getAllWorkflows();
        }
    }, []);

    useEffect(() => {
        let postsArray = JSON.parse(JSON.stringify(allWorkflowList));
        let newDataArray = [];
        postsArray.map((item, index) => {
            item.index = (
                <div className="compact-row-text">
                    {index + 1}
                </div>
            );
            item.workflowNameDisplay = (
                <div className="compact-row-text">
                    {item.name}
                </div>
            );
            item.categoriesDisplay = (
                <div className="compact-row-text badges-container">
                    {item.categories && item.categories.length > 0 ?
                        item.categories.map((cat, i) => (
                            <span key={i} className="badge badge-info mr-1">{cat.name}</span>
                        )) : '-'}
                </div>
            );
            item.action = (
                <div className="inline-actions">
                    <button type="button" className="btn btn-sm btn-default" title="View"
                        onClick={() => {
                            setSelectedRow(item);
                            setModalType(2);
                            setShowWorkflowModal(true);
                        }}
                    ><i className="fa fa-desktop"></i></button>
                    &nbsp;
                    <button type="button" className="btn btn-sm btn-default" title="Edit"
                        onClick={() => {
                            setSelectedRow(item);
                            setModalType(1);
                            setShowWorkflowModal(true);
                        }}
                    ><i className="fa fa-pencil-square-o"></i></button>
                    &nbsp;
                    <button type="button" className="btn btn-sm btn-default" title="Delete"
                        onClick={() => {
                            deleteWorkflow(item.id);
                        }}
                    ><i className="fa fa-trash"></i></button>
                </div>
            );
            newDataArray.push(item);
        });
        setWorkflowTableBody(newDataArray);
        setWorkflowForRender(newDataArray);
    }, [allWorkflowList]);

    const getAllWorkflows = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/workflow/branch/${selectedBranch.id}/get-all`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            let dataList = res.data.data;
            setAllWorkflowList(Array.isArray(dataList) ? dataList : []);
        }).catch((error) => {
            console.log(error);
            setAllWorkflowList([]);
        });
    };

    const filterSearch = (e) => {
        const keyword = e.target.value;
        setSearchText(keyword);
        if (keyword !== '') {
            const results = workflowForRender.filter((item) => {
                const nameMatch = (item.name || '').toLowerCase().includes(keyword.toLowerCase());
                const categoryMatch = (item.categories || []).some(cat => cat.toLowerCase().includes(keyword.toLowerCase()));
                return nameMatch || categoryMatch;
            });
            setWorkflowTableBody(results);
        } else {
            setWorkflowTableBody(workflowForRender);
        }
    };

    const deleteWorkflow = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this workflow!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    method: 'DELETE',
                    url: `${baseUrl}/workflow/${id}/delete`,
                    headers: {
                        Authorization: token
                    }
                }).then((res) => {
                    toast.success('Deleted successfully', { position: 'bottom-center' });
                    getAllWorkflows();
                }).catch((error) => {
                    toast.error('Something went wrong', { position: 'bottom-center' });
                });
            }
        });
    };

    return (
        <>
            <Toaster />
            <div className="container-fluid">
                <style>
                    {`
                        .compact-row-text {
                            padding: 0px !important;
                            margin: 0px !important;
                            font-size: 13px;
                        }
                        .inline-actions {
                            display: flex;
                            align-items: center;
                            gap: 5px;
                        }
                        .badges-container {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 4px;
                        }
                        .workflow-table td {
                            padding: 8px 10px !important;
                            vertical-align: middle !important;
                        }
                        .workflow-table th {
                            padding: 10px !important;
                        }
                    `}
                </style>
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Workflow</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/region-management">Region Management</Link></li>
                                    <li className="breadcrumb-item"><Link to={`/branch-landing?bid=${selectedBranch.id}`}>{selectedBranch.BranchName}</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Workflow</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <button className="btn btn-sm btn-primary" onClick={() => {
                                setModalType(0);
                                setSelectedRow({});
                                setShowWorkflowModal(true);
                            }}>Add New</button>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="body">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6">
                                        <div className="input-group header-counter-center">
                                            <h5>
                                                {searchText.length > 0 ? `${workflowTableBody.length} / ` : ''}
                                                <small className="text-muted">{allWorkflowList.length}</small>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6"></div>
                                    <div className="col-lg-5 col-md-6 ">
                                        <div className="input-group">
                                            <input type="text" className="form-control"
                                                value={searchText}
                                                onChange={filterSearch}
                                                placeholder="Search here..." />
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary" type="button">
                                                    <i className="fa fa-search" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body table-responsive">
                                <MDBDataTable
                                    noBottomColumns
                                    className="table table-hover js-basic-example dataTable table-custom spacing5 workflow-table"
                                    displayEntries={false}
                                    paging
                                    pagesAmount={15}
                                    data={body}
                                    searching={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <AddWorkflowModal
                    showWorkflowModal={showWorkflowModal}
                    setShowWorkflowModal={setShowWorkflowModal}
                    modalType={modalType}
                    selectedRow={selectedRow}
                    getAllWorkflows={getAllWorkflows}
                />
            </div>
        </>
    );
};

export default Workflow;